export function togglePass() {
    let $eyeButton = $(".eye");
    let $parentBlock = $eyeButton.parent();
    let $input = $parentBlock.find("input");

    $eyeButton.on("click", function () {
        $parentBlock.toggleClass("show-pass");
        let type = $input.attr("type") === "password" ? "text" : "password";
        $input.attr("type", type);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/togglePass.js